import axios from "axios";
import LogRocket from 'logrocket';
import "/node_modules/bxslider/src/css/jquery.bxslider.css";
import "/node_modules/jquery-typeahead/src/jquery.typeahead.css";
import { rootUrl } from "./config";
import "./styles-productbox.css";
import "./chilycategory.css";
import "./chilycheckout.css";
import "./chilymypage.css";
import "./mypage.css";
import "./signinpage.css";
import "./chilycontent.css";
import "./chilystyles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import * as bootstrap from "bootstrap";
import "./scss/custom.scss";
import "./font-awesome-4.7.0/fonts/FontAwesome.otf";
import "./font-awesome-4.7.0/fonts/fontawesome-webfont.eot";
import "./font-awesome-4.7.0/fonts/fontawesome-webfont.svg";
import "./font-awesome-4.7.0/fonts/fontawesome-webfont.ttf";
import "./font-awesome-4.7.0/fonts/fontawesome-webfont.woff";
import "./font-awesome-4.7.0/fonts/fontawesome-webfont.woff2";
//import Alpine from 'alpinejs';
import {
  hideTxtBarAtPos,
  deviceWidthToHideTxtBar,
  isClosePopupWhenScroll,
  txtBarMaxHeight,
  headerHeight,
  touchEnabled,
} from "./config";

import { loadProductLists, categoriesSlider } from "./product_list";
import { loadNotifyStockPopup, showSlider } from "./product_item";
import { getBasket, add2basket } from "./basket";
import { productSKUPriceEventsBinding, clearDataForProductDetail } from "./product_detail";
import { bindCheckoutEvents } from "./checkout";
import { bindSearchEvents } from "./search";
import { showAds, loadContentProductList } from "./content";
import { bindCustomerEvents, bindNotificationToUI } from "./customer";
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';

window.bootstrap = bootstrap;
var topbarSlider = null;
function freezeUI() {
  $("body").LoadingOverlay("show", {
    image: "",
    text: "",
    background: "rgba(255,255,255,0.3)",
    zIndex: 1003,
    fade: false,
  });
}

function unFreezeUI() {
  $("body").LoadingOverlay("hide", true);
}

function closePopup() {
  unFreezeUI();
  var basketPopup = $("div.popup-basket");
  if (basketPopup && basketPopup.length) {
    basketPopup[0].style.display = "none";
  }
}

window.addEventListener("click", function (event) {
  var mmenu = document.getElementById("mobile_menu");
  if (
    event.target != mmenu &&
    $(event.target).closest("div.mobile-menu-wrapper")[0] != mmenu
  ) {
    closeMobileMenu();
  }
});

function closeMobileMenu() {
  unFreezeUI();
  var mobileMenu = $("div.mobile-menu-wrapper");
  if (mobileMenu && mobileMenu.length) mobileMenu[0].style.display = "none";
}

function mobileMenuEventsBinding() {
  $(".menu-btn").on("click", function (evt) {
    freezeUI();
    evt.stopPropagation();
    if ($(".mobile-menu-wrapper").length) {
      if ($(".mobile-menu-wrapper")[0].style.display == "block") {
        $(".mobile-menu-wrapper").css({ display: "none" });
      } else {
        var basketEle = $("div.popup-basket");
        if (basketEle && basketEle.length) {
          basketEle[0].style.display = "none";
        }
        $(".mobile-menu-wrapper").css({ display: "block"});
        let w = $(window).width();
        let h = $(window).height()-10;
        if(w <= 576) $(".mobile-menu-wrapper").css({ "max-height": h});

      }
    }
  });

  $("button.navbar-toggler").on("click", function (evt) {
    unFreezeUI();
    evt.stopPropagation();
    if ($(".navbar-collapse").length) {
      if ($(".navbar-collapse")[0].style.display == "block") {
        $(".navbar-collapse").css({ display: "none" });
      } else {
        $(".navbar-collapse").css({ display: "block" });
      }
    }
  });

  $("button.sub-toogle").on("click", function (evt) {
    evt.stopPropagation();
    if (
      $(this).closest("li").find("div.menu_level2").length &&
      $(this).closest("li").find("div.menu_level2")[0].style.display == "block"
    ) {
      $(this).closest("li").find("div.menu_level2")[0].style.display = "none";
      $(this).find("i").removeClass("fa-angle-right").addClass("fa-angle-down");
    } else if ($(this).closest("li").find("div.menu_level2").length) {
      $(this).closest("li").find("div.menu_level2")[0].style.display = "block";
      $(this).find("i").removeClass("fa-angle-down").addClass("fa-angle-up");
    }
  });

  $("#header,#wex_wrap,button.wex-btn-close").on("click", function (evt) {
    unFreezeUI();
    var ele = $("div.mobile-menu-wrapper");
    if (ele && ele.length) {
      ele[0].style.display = "none";
    }
  });
}

function isCheckoutPage() {
  if ($("#checkout_page").length > 0) return true;
  return false;
}
function bindAdd2BasketEvent() {
  $("div.product-direct-search-container button.btn-addcart").on(
    "click",
    function (evt) {
      evt.stopPropagation();
      if (!$(this).hasClass("read-more"))
        add2basket(this, $(this).data("pid"), "direct_search");
      else {
        location.href = $(this)
          .closest(".product-wrapper")
          .find("a.product-url")
          .attr("href");
      }
    }
  );
  $("div.product-search-container button.btn-addcart").on("click", function (evt) {
    evt.stopPropagation();
    if (!$(this).hasClass("read-more"))
      add2basket(this, $(this).data("pid"), "search");
    else {
      location.href = $(this)
        .closest(".product-wrapper")
        .find("a.product-url")
        .attr("href");
    }
  });
}

function bindGoDetailEvent() {
  $("div.product-direct-search-container button.btn-godetail").on(
    "click",
    function (evt) {
      evt.stopPropagation();
      location.href = $(this)
        .closest(".product-wrapper")
        .find("a.product-url")
        .attr("href");
    }
  );
  $("div.product-search-container button.btn-godetail").on("click", function (evt) {
    evt.stopPropagation();
    location.href = $(this)
      .closest(".product-wrapper")
      .find("a.product-url")
      .attr("href");
  });
}

function bindSendContactFormEvents() {
  $("form[name='wgc_contact_form']").validate({
    rules: {
      contact_number: { required: true },
      contact_name: { required: true },
    },
    messages: {
      contact_number: $("input[name='contact_number']").data("errmsg"),
      contact_name: $("input[name='contact_name']").data("errmsg"),
    },
  });

  $("button[name='sendContactForm']").on("click", function (e) {
    e.stopPropagation();
    if ($("form[name='wgc_contact_form']").valid()) {
      //const data = $("form.wgc_contact_form").serialize();
      let cust_name = $("form[name='wgc_contact_form'] input[name='contact_name']").val();
      let cust_mail = $("form[name='wgc_contact_form'] input[name='contact_email']").val();
      let cust_mobile = $("form[name='wgc_contact_form'] input[name='contact_number']").val();
      let cust_message = $("form[name='wgc_contact_form'] textarea[name='contact_msg']").val();
      if (/(0)(3|5|7|8|9)+([0-9]{8})\b/.test(cust_mobile)) {
        $("form[name='wgc_contact_form'] .error-phone").text("");
        $("form[name='wgc_contact_form'] .formSent").text("Yêu cầu của bạn đã được gửi đi. Cảm ơn bạn đã gửi yêu cầu cho chúng tôi.");
        let url = `${rootUrl}/send-form`;
        axios({
          url: url,
          method: "POST",
          data: { name: cust_name, mail: cust_mail, mobile: cust_mobile, message: cust_message },
        })
          .then(function (res) {
            console.log(res.data);
          })
          .catch(function (err) {
            console.log(err);
          });
      } else {
        $("form[name='wgc_contact_form'] .formSent").text("");
        $("form[name='wgc_contact_form'] .error-phone").text("Số điện thoại không đúng định dạng!");
      }
    }
  });
}

function sliderEvents() {
  $(".top-bar .header-inner").on("init", function (event, slick) {
    console.log(event);
    console.log(slick);
  });
  $(".cat-container.brand-items").on(
    "afterChange",
    function (event, slick, currentSlide) {
      $(".cat-container.brand-products").slick("slickUnfilter");
      var aid = $(this).find(".slick-slide.slick-current").data("aid");
      $(".cat-container.brand-products").slick("slickFilter", ".agency-" + aid);
    }
  );
}

function toogleSliderTopbar(isOn) {
  if ( $("ul#menu").length ){
    var l = parseInt($("ul#menu").offset().left);
    $("ul#menu li.d_menu div.chily-menu").css({left: `${l}px`});
  }
  if (isOn) {
    $(".top-bar .header-inner").not(".slick-initialized").slick({
      dots: false,
      infinite: true,
      speed: 2000,
      fade: true,
      cssEase: "linear",
      arrows: false,
      autoplay: true,
    });
  } else {
    if ($(".top-bar .header-inner").hasClass(".slick-initialized"))
      $(".top-bar .header-inner").slick("unslick");
  }
}

function saveVoucher(voucherId, ele) {
  let url = `${rootUrl}/customer/saveVoucher`;
  const data = {voucherIdList: ["#" + voucherId]};
  axios({ url: url, method: "POST", data })
    .then(function (res) {
      if (!res.data.status) {
        location.href=`/customer/login?backUrl=/voucher`;
      } else {
        $(data.voucherIdList[0]).text("My voucher");
        $(data.voucherIdList[0]).attr('name', 'btn_my_voucher');
        $("button[name='btn_my_voucher']").on("click", function (evt) {
          evt.stopPropagation();
          location.href=`/customer/voucher`;
        });
      }
    })
    .catch(function (err) {
      console.log(err);
    });
}

function getElementsStartsWithId( elementId ) {
  var elems = document.getElementsByTagName("*");
  var matches = [];
  for (var i=0, m=elems.length; i<m; i++) {
      if (elems[i].id.includes(elementId)) {
         matches.push(elems[i].id);
      }
  }
  return matches;
}

function fallbackCopyTextToClipboard(text) {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  try {
    document.execCommand('copy');
  } catch (err) {
    console.error('Unable to copy to clipboard', err);
  }
  document.body.removeChild(textArea);
}

function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(function() {
    console.log('Async: Copying to clipboard was successful!');
  }, function(err) {
    console.error('Async: Could not copy text: ', err);
  });
}

$(window).on("resize", function () {
  toogleSliderTopbar($(window).width() <= deviceWidthToHideTxtBar);
});

$(document).ready(function () {
  //window.Alpine = Alpine
  //Alpine.start();
  LogRocket.init('g1m1vx/chilyweb');
  toogleSliderTopbar($(window).width() <= deviceWidthToHideTxtBar);
  var isSimpleHeader = $("#header").hasClass("is-simple-header");

  $(".mobile-menu-wrapper").css({ display: "none" });
  $("button.search-clear").css({ display: "none" });
  $('input[name="q"]').on("keyup", function (event) {
    var ele = $("button.search-clear");
    if ($('input[name="q"]').val() != "") ele.css({ display: "" });
    else ele.css({ display: "none" });
  });

  $("button.search-clear").on("click", function (evt) {
    evt.stopPropagation();
    var ele = $("button.search-clear");
    $('input[name="q"]').val("");
    ele.css({ display: "none" });
  });

  const observer = lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();
  $("button[name='member_register'],button[name='customer_mypage']").on(
    "click",
    function (evt) {
      evt.stopPropagation();
      closePopup();
      location.href = $(this).data("url");
    }
  );
  $("button[name='notifyStockSub']").on("click", function (evt) {
    evt.stopPropagation();
    loadNotifyStockPopup(this);
  });

  $("button[name='login_from_checkout']").on("click", function (evt) {
    evt.stopPropagation();
    let backUrl=$(this).data("backurl");
    location.href=`/customer/login?backUrl=${backUrl}`;
  });
  $("button[name='btn_save_voucher']").on("click", function (evt) {
    saveVoucher(evt.currentTarget.id, this);
  });

  if (!isCheckoutPage() && $("div.wex-mobile-basket").length) {
    getBasket(); // load basket
  } else {
    $("div.wex-mobile-basket").css({ display: "none" });
  }
  bindNotificationToUI();
  bindAdd2BasketEvent();
  bindGoDetailEvent();
  mobileMenuEventsBinding();
  loadProductLists();
  bindCheckoutEvents();
  bindCustomerEvents();
  showAds();
  bindSearchEvents();
  productSKUPriceEventsBinding();
  bindSendContactFormEvents();
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  });

  var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl)
  })

  var custVoucherList = getElementsStartsWithId("template_");
  for (var i=0, max=custVoucherList.length; i < max; i++) {
    const template = document.getElementById(custVoucherList[i]);
    const voucherDetailsId = '#voucher_details_' + custVoucherList[i].split("_")[1];
    tippy(voucherDetailsId, {
      content: template.innerHTML,
      allowHTML: true,
      interactive: true,
      theme: 'light',
      placement: 'auto',
      maxWidth: 333,
      onShown: function() {
        $("button[name='copy_voucher']").on("click", async function(evt){
          let voucher_elem = "voucher_code_" + evt.currentTarget.id.split("_")[2];
          let icon_copy = "#icon_copy_" + evt.currentTarget.id.split("_")[2];
          evt.stopPropagation();
          var copyText = document.getElementById(voucher_elem).innerHTML;
          copyTextToClipboard(copyText);
          if ($(icon_copy).hasClass("bi-clipboard")) {
            $(icon_copy).removeClass("bi-clipboard");
            $(icon_copy).addClass("bi-clipboard-check");
          }
        });
      }
    });
  }

  $(window).on("load", function () {
    // can also use window.addEventListener('load', (event) => {
    loadContentProductList();
    //loadSubscriptionPopup();

    clearDataForProductDetail();
    if ($("#header").hasClass("is-hidden-header")) {
      $("#wex_wrap .top-bar").css({ visibility: "hidden", transform: "scaleY(0)" });
      $("#wex_wrap .wex-header").css({ visibility: "hidden", transform: "scaleY(0)" });
      $("#wex_wrap .super-menu").css({ visibility: "hidden", transform: "scaleY(0)" });
      $("#floating_zalo .floating-button").css({ visibility: "hidden" });
    }
  });
  toogleSliderTopbar($(window).width() <= deviceWidthToHideTxtBar);
  var isSimpleHeader = $("#header").hasClass("is-simple-header");
  $(window).on("resize", function () {
    toogleSliderTopbar($(window).width() <= deviceWidthToHideTxtBar);
  });
  // Make category slider if any
  sliderEvents();
  categoriesSlider();

  $(window).on("scroll", function () {
    if (isClosePopupWhenScroll) {
      closePopup();
      if ($(window).width() >= deviceWidthToHideTxtBar) closeMobileMenu();
    }
    var navBar = $("div.navbar-collapse");
    if (navBar && navBar.length) {
      navBar[0].style.display = "none";
    }
    var mobileMenuWrapper = $("div.mobile-menu-wrapper");
    if (mobileMenuWrapper && mobileMenuWrapper.length) {
      mobileMenuWrapper[0].style.display = "none";
    }
    var isHiddenHeader = $("#header").hasClass("is-hidden-header");
    if (($("#wex_wrap .top-bar").length == 0) && isHiddenHeader) { // Apply for afiliate page
      if ($(document).scrollTop() > hideTxtBarAtPos) {
        $("#wex_wrap .top-bar").css({ visibility: "hidden", transform: "scaleY(0)" });
        $("#wex_wrap .wex-header").css({ visibility: "visible", transform: "scaleY(1)", transition: "top .4s ease-out", top: `0px` });
        $("#wex_wrap .super-menu").css({ visibility: "visible", transform: "scaleY(1)", top: `${headerHeight}px` });
        $("#floating_zalo .floating-button").css({ visibility: "visible", transition: "top .4s ease-out"});
      } else {
        $("#wex_wrap .wex-header").css({ visibility: "hidden", transform: "scaleY(0)" });
        $("#wex_wrap .super-menu").css({ visibility: "hidden", transform: "scaleY(0)" });
        $("#floating_zalo .floating-button").css({ visibility: "hidden" });
      }
    } else { // Apply for chily and newsale
      if (($(document).scrollTop() > hideTxtBarAtPos) || ($("#wex_wrap .top-bar").length == 0)) {
        $("#wex_wrap .top-bar").css({ visibility: "hidden", transform: "scaleY(0)" });
        $("#wex_wrap .wex-header").css({ visibility: "visible", transform: "scaleY(1)", transition: "top .2s ease-out", top: `0px` });
        $("#wex_wrap .super-menu").css({ visibility: "visible", transform: "scaleY(1)", top: `${headerHeight}px` });
      } else {
        $("#wex_wrap .top-bar").css({ visibility: "visible", transform: "scaleY(1)" });
        $("#wex_wrap .wex-header").css({
          transition: "top .2s ease-out",
          top: `${txtBarMaxHeight}px`,
        });
        $("#wex_wrap .super-menu").css({ top: `${headerHeight + txtBarMaxHeight}px` });
      }
    }
  });

  document.querySelectorAll("*").forEach((el) => {
    if (el.offsetWidth > document.documentElement.offsetWidth) {
      console.log("offsetWidth of bad element:",el.offsetWidth);
      console.log("offsetWidth of documentElement:",document.documentElement.offsetWidth.offsetWidth);
      console.log("Found the worst element ever: ", el);
    }
  });

  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      console.log("This page was restored from the bfcache.");
    } else {
      console.log("This page was loaded normally.");
    }
  });

  window.addEventListener("pagehide", function (event) {
    if (event.persisted === true) {
      console.log("This page *might* be entering the bfcache.");
    } else {
      console.log("This page will unload normally and be discarded.");
    }
  });
});

export {bindAdd2BasketEvent}
